import PropTypes from 'prop-types';
import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import Business from '@material-ui/icons/Business';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import DirectionsBus from '@material-ui/icons/DirectionsBus';
import Person from '@material-ui/icons/Person';
import RestorePage from '@material-ui/icons/RestorePage';
import Timeline from '@material-ui/icons/Timeline';

import RideExportBar from './RideExportBar';
import LeftBarHeader from './header';
import { DirectionsRailway } from "@material-ui/icons";


/**
 * Route blockage management menu bar.
 */
const RouteBlockageBar = ({ handleToggleLeftBar, handleToggleLeftBarModule, isAdmin, module }) => (
  <div>
    <LeftBarHeader
      handleToggleLeftBar={handleToggleLeftBar}
      title="Stremmingen"
      icon={<Timeline />}
    />

    <List component="nav">
      <ListItem
        button
        key="routeBlockage-overview"
        onClick={() => handleToggleLeftBarModule('routeBlockageList')}
      >
        <ListItemText primary="Overzicht stremmingen" />
        {module === 'routeBlockageList' ? <ChevronLeft /> : <ChevronRight />}
      </ListItem>

      {isAdmin && (
        <ListItem
          button
          key="routeBlockage-create"
          onClick={() => handleToggleLeftBarModule('addRouteBlockage')}
        >
          <ListItemText primary="Stremming aanmaken" />
          {module === 'addRouteBlockage' ? <ChevronLeft /> : <ChevronRight />}
        </ListItem>
      )}
    </List>
  </div>
);

RouteBlockageBar.propTypes = {
  handleToggleLeftBar: PropTypes.func.isRequired,
  handleToggleLeftBarModule: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  module: PropTypes.string,
};

RouteBlockageBar.defaultProps = {
  module: '',
};

/**
 * Company management menu bar.
 */
const CompanyBar = ({ handleToggleLeftBar, handleToggleLeftBarModule, isAdmin, module }) => (
  <div>
    <LeftBarHeader
      handleToggleLeftBar={handleToggleLeftBar}
      title="Bedrijven"
      icon={<Business />}
    />

    <List component="nav">
      <ListItem
        button
        key="company-overview"
        onClick={() => handleToggleLeftBarModule('companyList')}
      >
        <ListItemText primary="Overzicht bedrijven" />
        {module === 'companyList' ? <ChevronLeft /> : <ChevronRight />}
      </ListItem>

      {isAdmin && (
        <ListItem
          button
          key="company-create"
          onClick={() => handleToggleLeftBarModule('companyAdd')}
        >
          <ListItemText primary="Bedrijf toevoegen" />
          {module === 'companyAdd' ? <ChevronLeft /> : <ChevronRight />}
        </ListItem>
      )}
    </List>
  </div>
);

CompanyBar.propTypes = {
  handleToggleLeftBar: PropTypes.func.isRequired,
  handleToggleLeftBarModule: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  module: PropTypes.string,
};

CompanyBar.defaultProps = {
  module: '',
};

/**
 * Bus management menu bar.
 */
const BusBar = ({ handleToggleLeftBar, handleToggleLeftBarModule, isAdmin, isSubcontractor, module }) => (
  <div>
    <LeftBarHeader
      handleToggleLeftBar={handleToggleLeftBar}
      title="Bussen"
      icon={<DirectionsBus />}
    />

    <List component="nav">
      <ListItem
        button
        key="bus-overview"
        onClick={() => handleToggleLeftBarModule('busList')}
      >
        <ListItemText primary="Overzicht bussen" />
        {module === 'busList' ? <ChevronLeft /> : <ChevronRight />}
      </ListItem>

      {(isAdmin || isSubcontractor) && (
        <ListItem
          button
          key="bus-add"
          onClick={() => handleToggleLeftBarModule('busAdd')}
        >
          <ListItemText primary="Bus toevoegen" />
          {module === 'busAdd' ? <ChevronLeft /> : <ChevronRight />}
        </ListItem>
      )}
    </List>
  </div>
);

BusBar.propTypes = {
  handleToggleLeftBar: PropTypes.func.isRequired,
  handleToggleLeftBarModule: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isSubcontractor: PropTypes.bool.isRequired,
  module: PropTypes.string,
};

BusBar.defaultProps = {
  module: '',
};

/**
 * ApiUser management menu bar.
 */
const ApiUserBar = ({ handleToggleLeftBar, handleToggleLeftBarModule, module }) => (
  <div>
    <LeftBarHeader
      handleToggleLeftBar={handleToggleLeftBar}
      title="Gebruikers"
      icon={<Person />}
    />

    <List component="nav">
      <ListItem
        button
        key="api-user-overview"
        onClick={() => handleToggleLeftBarModule('apiUserList')}
      >
        <ListItemText primary="Overzicht gebruikers" />
        {module === 'apiUserList' ? <ChevronLeft /> : <ChevronRight />}
      </ListItem>

      <ListItem
        button
        key="api-user-add"
        onClick={() => handleToggleLeftBarModule('apiUserAdd')}
      >
        <ListItemText primary="Gebruiker toevoegen" />
        {module === 'apiUserAdd' ? <ChevronLeft /> : <ChevronRight />}
      </ListItem>
    </List>
  </div>
);

ApiUserBar.propTypes = {
  handleToggleLeftBar: PropTypes.func.isRequired,
  handleToggleLeftBarModule: PropTypes.func.isRequired,
  module: PropTypes.string,
};

ApiUserBar.defaultProps = {
  module: '',
};

/**
 * Ride administrative management menu bar.
 */
const RideAdminBar = ({ handleToggleLeftBar, handleToggleLeftBarModule, module }) => (
  <div>
    <LeftBarHeader
      handleToggleLeftBar={handleToggleLeftBar}
      title="Ritten"
      icon={<RestorePage />}
    />

    <List component="nav">
      <ListItem button onClick={() => handleToggleLeftBarModule('RideAdminActiveList')}>
        <ListItemText primary="Actieve ritten" />
        {module === 'RideAdminActiveList' ? <ChevronLeft /> : <ChevronRight />}
      </ListItem>

      <ListItem button onClick={() => handleToggleLeftBarModule('RideAdminInactiveList')}>
        <ListItemText primary="Afgeronde ritten" />
        {module === 'RideAdminInactiveList' ? <ChevronLeft /> : <ChevronRight />}
      </ListItem>
    </List>
  </div>
);

RideAdminBar.propTypes = {
  handleToggleLeftBar: PropTypes.func.isRequired,
  handleToggleLeftBarModule: PropTypes.func.isRequired,
  module: PropTypes.string,
};

RideAdminBar.defaultProps = {
  module: '',
};

const RailwayBar =({ isAdmin, handleToggleLeftBar, handleToggleLeftBarModule, module }) => (
  <div>
    <LeftBarHeader
      handleToggleLeftBar={handleToggleLeftBar}
      title="Spoorwegen"
      icon={<DirectionsRailway />}
    />

    <List component="nav">
      {isAdmin && (
        <ListItem
          button
          key="railway-overview"
          onClick={() => handleToggleLeftBarModule('railwayList')}
        >
          <ListItemText primary="Overzicht spoorwegen" />
          {module === 'railwayList' ? <ChevronLeft /> : <ChevronRight />}
        </ListItem>
      )}
    </List>
  </div>
)

RailwayBar.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  handleToggleLeftBar: PropTypes.func.isRequired,
  handleToggleLeftBarModule: PropTypes.func.isRequired,
  module: PropTypes.string,
};

RailwayBar.defaultProps = {
  module: '',
};

/**
 * Exports.
 */
export default {
  'routeBlockage': RouteBlockageBar,
  'company': CompanyBar,
  'bus': BusBar,
  'apiUser': ApiUserBar,
  'RideAdmin': RideAdminBar,
  'RideExport': RideExportBar,
  'railwayAdmin': RailwayBar,
};
